import { TitleCasePipe } from "@angular/common";
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { FormBuilder, FormArray, Validators, FormGroup } from "@angular/forms";
import { MenuItem, MessageService } from "primeng/api";
import { AppMainService } from "src/app/app-main.service";
import { PackBoxService } from "src/app/configurations/inventory/setup/pack-box/pack-box.service";
import { Severity } from "src/app/inventory/constants/constants";
import { Status } from "src/app/models/statusEnums";
import * as moment from "moment";
import { SalesOrderService } from "src/app/inventory/sales-order/sales-order.service";
import { SOChannel, SoStageId } from "src/app/inventory/sales-order/constants/constants";
import { ImportserialService } from "../../services/importserial.service";
import { Subject, takeUntil } from "rxjs";
@Component({
    selector: "app-fedex-shipment",
    templateUrl: "./fedex-shipment.component.html",
    styleUrls: ["./fedex-shipment.component.scss"],
})
export class FedexShipmentComponent implements OnInit {
    @Input() detailsObj;
    @Input() channel;
    @Input() vendorFedexInfo;
    @Input() fedexAccountInfo;
    @Input() allShippingMethods;
    @Input() allFedexAccounts;
    @Input() selectedCarrier;
    @Input() displayAddPackage;
    @Input() selectedFedexAcc;

    @Output() onFedexLabelCreate = new EventEmitter();
    @Output() onStepChange = new EventEmitter();
    @Output() onClose = new EventEmitter();
    @ViewChild("stepper") stepper: ElementRef;
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    menus: MenuItem[];
    activeIndex = 0;
    packageType = [];
    
    packageOptions = [
        { id: 1, label: "1", value: 1 },
        { id: 2, label: "2", value: 2 },
        { id: 3, label: "3", value: 3 },
        { id: 4, label: "4" ,value: 4 },
        { id: 5, label: "5" ,value: 5 },
        { id: 6, label: "6" ,value: 6 },
        { id: 7, label: "7" ,value: 7 },
        { id: 8, label: "8" ,value: 8 },
        { id: 9, label: "9" ,value: 9 },
        { id: 10, label: "10" , value: 10 },
        { id: 11, label: "11" , value: 11 },
        { id: 12, label: "12" , value: 12 },
        { id: 13, label: "13" , value: 13 },
        { id: 14, label: "14" , value: 14 },
        { id: 15, label: "15" , value: 15 },
        { id: 16, label: "16" , value: 16 },
        { id: 17, label: "17" , value: 17 },
        { id: 18, label: "18" , value: 18 },
        { id: 19, label: "19" , value: 19 },
        { id: 20, label: "20" , value: 20 },
        { id: 21, label: "21" , value: 21 },
        { id: 22, label: "22" , value: 22 },
        { id: 23, label: "23" , value: 23 },
        { id: 24, label: "24" , value: 24 },
        { id: 25, label: "25" , value: 25 },
    ];

    massOptions = [
        { id: 1, name: "Pound", code: "POUND" },
        { id: 2, name: "Kilogram", code: "KILOGRAM" },
        { id: 3, name: "Ounce", code: "OUNCE" },
        { id: 4, name: "Stone", code: "STONE" },
    ];
    selectedOption: string[] = [];
    packageGroup = [{}];
    services = [
        {
            id: 1,
            name: "UPS Ground",
            deliverBy: "Monday 07/11/22 by end of Day",
            cost: "$87.25",
        },
        {
            id: 2,
            name: "UPS Express",
            deliverBy: "Friday 07/18/22 by end of Day",
            cost: "$127.25",
        },
    ];
    selectedService;
    shippingAddress;
    form:FormGroup = this.fb.group({
        packages: this.fb.array([]),
    });
    shipmentRates = [];
    shipment;
    isSinglePackage = false;
    order;
    allPackBoxes = [];
    defaultPackage;
    paymentMethod = [];
    defaultMethod;
    ratesText;
    createLabelSubmitted = false;

    minimumDate = new Date();
    pickupTypeList = [
        {
            id: 1,
            name: "Contact Fedex to Schedule",
            value: "CONTACT_FEDEX_TO_SCHEDULE",
        },
        {
            id: 2,
            name: "Dropoff at Fedex location",
            value: "DROPOFF_AT_FEDEX_LOCATION",
        },
        {
            id: 3,
            name: "Use Scheduled Pickup",
            value: "USE_SCHEDULED_PICKUP",
        },
    ];
    childShippingMethods = [];
    shippingAddressContact;

    codAmount = 0;
    isVisibleShipCostField = false;
    shippingCost = 0;
    isVisibleCodField = false;
    isFreeShipping = false;
    soChannel = SOChannel;

    serviceTypes = [];
    
    // TODO: Need to remove this once special service integration completed
    // serviceTypes = [
    //     {
    //         label: '', value: '',
    //         items: [
    //             {label: 'First Overnight', value: 'first-overnight',group:1},
    //             {label: 'Priority Overnight', value: 'priority-overnight',group:1},
    //             {label: 'Standard Overnight', value: 'standard-overnight',group:1},
    //             {label: 'FedEx 2Day AM', value: 'fedex-2day-am',group:1},
    //             {label: 'FedEx 2Day', value: 'fedex-2day',group:1},
    //         ]
    //     },
    //     {
    //         label:"",value:"",
    //         items:[
    //             {label:"FedEx Ground",value: 'fedex-ground',group:2},
    //         ]
    //     },
    //     {
    //         label: '', value: '',
    //         items: [
    //             {label: 'FedEx First Overnight Freight', value: 'fedex-first-overnight-freight',group:3},
    //             {label: 'FedEx 1Day Freight', value: 'fedex-1day-freight',group:3},
    //             {label: 'FedEx 2Day Freight', value: 'fedex-2day-freight',group:3},
    //             {label: 'FedEx 3Day Freight', value: 'fedex-3day-freight',group:3}
    //         ]
    //     },
    // ];

    selectedServiceType;
    dryIceChecked: boolean = false;
    batteryChecked: boolean = false;
    batteries = [
        {id:1, name:"Ion Packed with Equipment (UN3481, P1966)", packingType: "PACKED_WITH_EQUIPMENT", materialType: "LITHIUM_ION"},
        {id:2, name:"Ion Contained with Equipment (UN3481, P1987)", packingType: "CONTAINED_IN_EQUIPMENT", materialType: "LITHIUM_ION"},
        {id:3, name:"Metal Packed with Equipment (UN3091, P1969)", packingType: "PACKED_WITH_EQUIPMENT", materialType: "LITHIUM_METAL"},
        {id:4, name:"Metal Contained with Equipment (UN3091, P1970)", packingType: "CONTAINED_IN_EQUIPMENT", materialType: "LITHIUM_METAL"},
    ];
    // signatureTypes = [
    //     {id:1,name:"None Specified"},
    //     {id:2,name:"Direct Signature Required"},
    //     {id:3,name:"Adult Signature Required"},
    // ];
    signatureTypes = [];
    isVisibleBatteryField = false;
    // fraction digits
    fractionDigits: number = 0;

    configuredFedexShippingServices: any[] = [];
    
    saturdayDeliveryAvailable: boolean = false;
    isSaturdayDeliveryChecked: boolean = false;
    saturdaySpecialServiceType = "SATURDAY_DELIVERY";

    constructor(
        private fb: FormBuilder,
        private salesOrderService: SalesOrderService,
        private packBoxService: PackBoxService,
        private messageService: MessageService,
        private titlecasePipe: TitleCasePipe,
        private appMainService: AppMainService,
        private importService: ImportserialService
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.detailsObj && changes.detailsObj.currentValue) {
            this.detailsObj = changes.detailsObj.currentValue;
            this.shippingAddress = this.detailsObj?.account?.accountAddresses?.filter((d) => d.addressId == this.detailsObj.shippingAddressId)[0];
            this.paymentMethod = [];
            if (this.detailsObj?.account?.accountPaymentMethods) {
                this.detailsObj?.account?.accountPaymentMethods.forEach((e) => {
                    this.paymentMethod.push(e.paymentMethod);
                    if (e.isDefault) {
                        this.defaultMethod = e.paymentMethod;
                    }
                });
            }
            this.shippingAddressContact = this.detailsObj?.shipContact;
        }
        if (changes.vendorFedexInfo && changes.vendorFedexInfo.currentValue) {
            this.vendorFedexInfo = changes.vendorFedexInfo.currentValue;
        }
        if (changes.displayAddPackage && changes.displayAddPackage.currentValue) {
            this.displayAddPackage = changes.displayAddPackage.currentValue;
            if (this.displayAddPackage) {
                this.initForm();
                this.addPackage();
            }
        }
        this.activeIndex = 0;
        this.createLabelSubmitted = false;
        this.selectedService = null;
        this.filterChildShippingMethods();
        if(this.allShippingMethods && this.allShippingMethods?.length > 0){
            this.filterFedexShippingServices();
        }   
    }

    ngOnInit(): void {
        this.getFractionDigits();
        this.menus = [{}, {}, {}, {}];
        this.getAllPackBoxList();
    }
    getFractionDigits() {
        this.importService
            .getDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (value) => {
                    if(value){
                        this.fractionDigits = value;
                    }
                },
                error: (error) => {},
            });
    }

    filterFedexShippingServices(){
        this.configuredFedexShippingServices = this.allShippingMethods?.find((s) => s?.name?.toLowerCase() == "fedex")?.childShippingMethod ?? [];
    }

    filterChildShippingMethods() {
        if (this.detailsObj && this.detailsObj.shippingMethodId && this.allShippingMethods) {
            const d = this.allShippingMethods.filter((s) => s.id == this.detailsObj.shippingMethodId)[0];
            this.childShippingMethods = d?.childShippingMethod && d?.childShippingMethod?.length ? d.childShippingMethod : [];
        }
    }

    getAllPackBoxList() {
        this.packageType = [];
        this.packBoxService.getPackBoxListWithHierarchy().subscribe(
            (res) => {
                this.allPackBoxes = res;
                const allPackages = [];
                let defaultChild;
                if (this.allPackBoxes && this.allPackBoxes.length) {
                    this.allPackBoxes.forEach((box) => {
                        if (box.statusId == Status.Active) {
                            const child = [];
                            if (box.childPackBoxes && box.childPackBoxes.length) {
                                box.childPackBoxes.forEach((ch) => {
                                    if (ch.statusId == Status.Active) {
                                        const childData = {
                                            label: ch.name,
                                            value: ch.id,
                                            data: ch,
                                        };
                                        child.push(childData);
                                        if (ch.isDefault) {
                                            defaultChild = childData;
                                        }
                                    }
                                });
                            }
                            const parentData = {
                                label: box.name,
                                value: box.id,
                                children: child,
                                data: box,
                            };
                            allPackages.push(parentData);
                            if (box.isDefault && defaultChild && defaultChild.data.parentId == box.id) {
                                this.defaultPackage = defaultChild;
                            }
                        }
                    });
                }
                this.packageType = allPackages;
            },
            (error) => {
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(Severity.Error),
                    detail: "Error occurred...",
                });
            },
        );
    }

    initForm() {
        this.form = this.fb.group({
            packages: this.fb.array([]),
        });
    }

    editPackage() {}

    backStep(step) {
        var arr = document.getElementsByClassName("p-steps-item");
        for (let i in this.menus) {
            if (i >= step) {
                arr[i].classList.remove("activeItem");
            }
        }
        this.activeIndex = this.activeIndex - 1;
        if (step == 2) {
            this.selectedService = null;
            this.isSaturdayDeliveryChecked = false;
        } else if (step == 3) {
            this.createLabelSubmitted = false;
        }
        if (this.activeIndex == 0) {
            this.onStepChange.emit(true);
        }
    }

    nextStep(step) {
        var arr = document.getElementsByClassName("p-steps-item");
        for (let i in this.menus) {
            if (i < step + 1) {
                arr[i].classList.add("activeItem");
            }
        }
        if (step == 0) {
            this.getShippingServices();
        } else if (step == 1) {
            this.getShippingCost();
        } else if (step == 2) {
            this.shippingCost = this.selectedService?.ratedShipmentDetails[0]?.totalNetFedExCharge || 0;
            this.calculateCODAmount();
        }
        this.activeIndex = this.activeIndex + 1;
        if (this.activeIndex > 0) {
            this.onStepChange.emit(false);
        }
    }

    get packages() {
        return this.form.controls["packages"] as FormArray;
    }

    addPackage() {
        const defaultService = this.configuredFedexShippingServices?.find((s) => s.isDefault == true);
        const defaultServiceType = this.serviceTypes?.[0]?.items?.find((s) => s.label == defaultService.description);
        const packagreForm = this.fb.group({
            account: [this.fedexAccountInfo, Validators.required],
            serviceType: [defaultServiceType && defaultServiceType.label ? defaultServiceType.label : null, Validators.required],
            packageType: [this.defaultPackage, Validators.required],
            totalPackage: [{ id: 1, label: "1", value: 1 }],
            mass: [this.massOptions[0]],
            weight: [this.defaultPackage ? this.defaultPackage.data.weight : "", Validators.required],
            length: [this.defaultPackage ? this.defaultPackage.data.length : "", Validators.required],
            width: [this.defaultPackage ? this.defaultPackage.data.width : "", Validators.required],
            height: [this.defaultPackage ? this.defaultPackage.data.height : "", Validators.required],
            packageValue: [this.detailsObj ? this.detailsObj.totalAmount : 0],
            reference1: [this.channel == "SALESORDER" && this.detailsObj.salesOrderStageId == SoStageId.Shipped ? this.detailsObj?.invoiceNo : this.detailsObj?.number, Validators.required],
            reference2: [""],
            shipDate: [new Date(), Validators.required],
            pickupType: [this.pickupTypeList[2]],
            codAmount: ["17.5"],
            codMethod: [this.defaultMethod ? this.defaultMethod : ""],
            includeBatteries: [false],
            signature: [false],
            cod: [false],
            oversizedPackage: [false],
            dryIceWeight: [0],
            signatureType: [null],
            batteryType:[null],
            selectedCity: [null],
        });
        this.packages.push(packagreForm);
    }

    onPackageTypeChage(index) {
        const pType = this.packages.at(index).get("packageType").value?.data;
        if (!pType) {
            this.packages.at(index).get("length").setValue("");
            this.packages.at(index).get("width").setValue("");
            this.packages.at(index).get("height").setValue("");
            this.packages.at(index).get("weight").setValue("");
        } else if (pType.name && pType.name.startsWith("FEDEX")) {
            this.packages.at(index).get("length").setValue(pType.length);
            this.packages.at(index).get("width").setValue(pType.width);
            this.packages.at(index).get("height").setValue(pType.height);
            this.packages.at(index).get("weight").setValue(pType.weight);

            this.packages.at(index).get("length").disable();
            this.packages.at(index).get("width").disable();
            this.packages.at(index).get("height").disable();
            this.packages.at(index).get("weight").disable();
        } else {
            this.packages.at(index).get("length").setValue(pType.length);
            this.packages.at(index).get("width").setValue(pType.width);
            this.packages.at(index).get("height").setValue(pType.height);
            this.packages.at(index).get("weight").setValue(pType.weight);

            this.packages.at(index).get("length").enable();
            this.packages.at(index).get("width").enable();
            this.packages.at(index).get("height").enable();
            this.packages.at(index).get("weight").enable();
        }
    }

    getFormGroupAt(index) {
        return this.packages.at(index) as FormGroup;
    }

    removePackage(index: number) {
        this.packages.removeAt(index);
    }

    /** Ship from and to address */

    prepareShipFromAddress(obj) {
        const shippingFromAddressObj = {
            contact: {
                personName: obj?.warehouse?.name,
                phoneNumber: obj?.warehouse?.phoneNo,
                companyName: obj?.warehouse?.name,
            },
            address: {
                streetLines: [this.prepareShipperStreetAddress(obj)],
                city: obj?.warehouse?.address?.city?.name,
                stateOrProvinceCode: obj?.warehouse?.address?.state?.name,
                postalCode: obj?.warehouse?.address?.zipCode,
                countryCode: obj?.warehouse?.address?.country?.countryCode || "US",
                residential: false,
            },
        };
        return shippingFromAddressObj;
    }
    prepareShipToAddress(shippingAddress, obj) {
        const shippingToAddressObj = {
            contact: {
                personName: this.checkNameLength(this.getShipToContactName()),
                phoneNumber: obj?.shipContact && obj?.shipContact?.contactPhones && obj?.shipContact?.contactPhones[0]?.phone && obj?.shipContact?.contactPhones[0]?.phone?.number ? obj?.shipContact?.contactPhones[0]?.phone?.number : shippingAddress?.address?.attnContact && shippingAddress?.address?.attnContact?.contactPhones && shippingAddress?.address?.attnContact?.contactPhones?.length ? shippingAddress?.address?.attnContact?.contactPhones[0]?.phone?.number : "",
                // companyName: this.checkNameLength(this.detailsObj?.account?.businessName),
                companyName: this.checkNameLength(shippingAddress?.address?.addressName && shippingAddress?.address?.addressName?.length > 0 ? shippingAddress?.address?.addressName :this.detailsObj?.account?.businessName),
            },
            address: {
                streetLines: [this.prepareShipToStreetAddress(shippingAddress)],
                city: shippingAddress?.address?.city?.name,
                stateOrProvinceCode: shippingAddress?.address?.state?.name,
                postalCode: shippingAddress?.address?.zipCode,
                countryCode: shippingAddress?.warehouse?.address?.country?.countryCode || "US",
                residential: false,
            },
        };
        return shippingToAddressObj;
    }
    prepareShipperStreetAddress(obj) {
        let address = "";
        if (obj?.warehouse?.address?.streetAddress1) {
            address += obj?.warehouse?.address?.streetAddress1 ?? "";
        }
        if (obj?.warehouse?.address?.streetAddress1 && obj?.warehouse?.address?.streetAddress2) {
            address += ",";
        }
        if (obj?.warehouse?.address?.streetAddress2) {
            address += obj?.warehouse?.address?.streetAddress2 ?? "";
        }

        if (address.length > 35) {
            return address.substring(0, 35);
        } else {
            return address;
        }
    }
    prepareShipToStreetAddress(shipAddress) {
        let address = "";
        if (shipAddress?.address?.streetAddress1) {
            address += shipAddress?.address?.streetAddress1 ?? "";
        }
        if (shipAddress?.address?.streetAddress1 && shipAddress?.address?.streetAddress2) {
            address += ",";
        }
        if (shipAddress?.address?.streetAddress2) {
            address += shipAddress?.address?.streetAddress2 ?? "";
        }

        if (address.length > 35) {
            return address.substring(0, 35);
        } else {
            return address;
        }
    }
    getShipToContactName() {
        let contactName = "";
        if (this.shippingAddressContact?.firstName && this.shippingAddressContact?.lastName) {
            contactName = this.shippingAddressContact.firstName + " " + this.shippingAddressContact.lastName;
        } else if (this.shippingAddressContact?.firstName) {
            contactName = this.shippingAddressContact.firstName;
        } else if (this.shippingAddressContact?.lastName) {
            contactName = this.shippingAddressContact.lastName;
        } else {
            contactName = this.detailsObj?.account?.businessName || "";
        }
        return contactName;
    }
    prepareCodRecipient(obj) {
        const formValue = this.form.value.packages[0];
        let codRecipient = {
            address: {
                streetLines: [this.prepareShipperStreetAddress(obj)],
                city: obj?.warehouse?.address?.city?.name,
                stateOrProvinceCode: obj?.warehouse?.address?.state?.name,
                postalCode: obj?.warehouse?.address?.zipCode,
                countryCode: obj?.warehouse?.address?.country?.countryCode || "US",
                residential: false,
            },
            contact: {
                personName: obj?.warehouse?.name,
                phoneNumber: obj?.warehouse?.phoneNo,
                companyName: obj?.warehouse?.name,
            },
            accountNumber: {
                // value: formValue.account?.accountNumber,
                value: this.selectedFedexAcc?.accountNumber ?? "",
            },
        };
        return codRecipient;
    }

    /** End Ship from and to address */

    /** Customer return ship from and to address */
    /** Customer return shipfrom address */
    prepareCustomerReturnShipFromAddress(shippingAddress, obj) {
        const shippingFromAddressObj = {
            contact: {
                personName: this.checkNameLength(this.getShipToContactName()),
                phoneNumber: obj?.shipContact && obj?.shipContact?.contactPhones && obj?.shipContact?.contactPhones[0]?.phone && obj?.shipContact?.contactPhones[0]?.phone?.number ? obj?.shipContact?.contactPhones[0]?.phone?.number : shippingAddress?.address?.attnContact && shippingAddress?.address?.attnContact?.contactPhones && shippingAddress?.address?.attnContact?.contactPhones?.length ? shippingAddress?.address?.attnContact?.contactPhones[0]?.phone?.number : "",
                // companyName: this.checkNameLength(this.detailsObj?.account?.businessName),
                companyName: this.checkNameLength(shippingAddress?.address?.addressName && shippingAddress?.address?.addressName?.length > 0 ? shippingAddress?.address?.addressName :this.detailsObj?.account?.businessName),
            },
            address: {
                streetLines: [this.prepareShipToStreetAddress(shippingAddress)],
                city: shippingAddress?.address?.city?.name,
                stateOrProvinceCode: shippingAddress?.address?.state?.name,
                postalCode: shippingAddress?.address?.zipCode,
                countryCode: shippingAddress?.warehouse?.address?.country?.countryCode || "US",
                residential: false,
            },
        };
        return shippingFromAddressObj;
    }
    /** Customer return shipto address */
    prepareCustomerReturnShipToAddress(obj) {
        const shippingToAddressObj = {
            contact: {
                personName: obj?.warehouse?.name,
                phoneNumber: obj?.warehouse?.phoneNo,
                companyName: obj?.warehouse?.name,
            },
            address: {
                streetLines: [this.prepareShipperStreetAddress(obj)],
                city: obj?.warehouse?.address?.city?.name,
                stateOrProvinceCode: obj?.warehouse?.address?.state?.name,
                postalCode: obj?.warehouse?.address?.zipCode,
                countryCode: obj?.warehouse?.address?.country?.countryCode || "US",
                residential: false,
            },
        };
        return shippingToAddressObj;
    }
    /** Customer return COD address */
    prepareCustomerReturnCodRecipient(shippingAddress, obj) {
        const formValue = this.form.value.packages[0];
        let codRecipient = {
            contact: {
                personName: this.checkNameLength(this.getShipToContactName()),
                phoneNumber: obj?.shipContact && obj?.shipContact?.contactPhones && obj?.shipContact?.contactPhones[0]?.phone && obj?.shipContact?.contactPhones[0]?.phone?.number ? obj?.shipContact?.contactPhones[0]?.phone?.number : shippingAddress?.address?.attnContact && shippingAddress?.address?.attnContact?.contactPhones && shippingAddress?.address?.attnContact?.contactPhones?.length ? shippingAddress?.address?.attnContact?.contactPhones[0]?.phone?.number : "",
                // companyName: this.checkNameLength(this.detailsObj?.account?.businessName),
                companyName: this.checkNameLength(shippingAddress?.address?.addressName && shippingAddress?.address?.addressName?.length > 0 ? shippingAddress?.address?.addressName :this.detailsObj?.account?.businessName),
            },
            address: {
                streetLines: [this.prepareShipToStreetAddress(shippingAddress)],
                city: shippingAddress?.address?.city?.name,
                stateOrProvinceCode: shippingAddress?.address?.state?.name,
                postalCode: shippingAddress?.address?.zipCode,
                countryCode: shippingAddress?.warehouse?.address?.country?.countryCode || "US",
                residential: false,
            },
            accountNumber: {
                // value: formValue.account?.accountNumber,
                value: this.selectedFedexAcc?.accountNumber ?? "",
            },
        };
        return codRecipient;
    }
    /** End Customer return ship from and to address */

    /** Shipment rates */
    getShippingCost() {
        if (this.form.value && this.form.value.packages && this.form.value.packages.length) {
            if (this.form.value.packages.length > 1) {
                this.isSinglePackage = false;
                this.getMultiplePackageShippingCost();
            } else {
                this.isSinglePackage = true;
                this.getSinglePackageShippingCost();
            }
        }
    }
    getMultiplePackageShippingCost() {
        const shipments = [];
        let totalWeight = 0;
        this.form.value.packages.forEach((pck) => {
            for (let i = 0; i < Number(pck.totalPackage.value); i++) {
                const obj = {
                    groupPackageCount: 1,
                    weight: {
                        units: "LB",
                        value: Number(pck.weight),
                    },
                    dimensions: {
                        length: pck.length ? Number(pck.length) : 0,
                        width: pck.width ? Number(pck.width) : 0,
                        height: pck.height ? Number(pck.height) : 0,
                        units: "IN",
                    },
                };
                totalWeight += Number(pck.weight);
                shipments.push(obj);
            }
        });
        const formValue = this.form.value.packages[0];
        const ratesReqData = {
            accountNumber: {
                // value: formValue.account?.accountNumber,
                value: this.selectedFedexAcc?.accountNumber ?? "",
            },
            requestedShipment: {
                shipper: this.channel != this.soChannel.CUSTOMER_RETURNS ? this.prepareShipFromAddress(this.detailsObj) : this.prepareCustomerReturnShipFromAddress(this.shippingAddress, this.detailsObj),
                recipient: this.channel != this.soChannel.CUSTOMER_RETURNS ? this.prepareShipToAddress(this.shippingAddress, this.detailsObj) : this.prepareCustomerReturnShipToAddress(this.detailsObj),
                pickupType: formValue.pickupType?.value,
                ...(formValue.serviceType && formValue.serviceType && {
                    serviceType: formValue.serviceType ?? 0,
                }),
                packagingType:
                    formValue?.packageType?.label && formValue?.packageType?.label.startsWith("FEDEX") // CHECK-FEDEX
                        ? formValue?.packageType?.label
                        : "YOUR_PACKAGING",
                totalPackageCount: 1,
                totalWeight: totalWeight,
                rateRequestType: ["ACCOUNT", "LIST"],
                requestedPackageLineItems: shipments,
            },
        };
        let objEncStr = btoa(JSON.stringify(ratesReqData));
        this.shipmentRates = [];
        this.appMainService.isShowSpinner("loadrates");
        this.salesOrderService.getFedexRates(this.vendorFedexInfo?.id, objEncStr).subscribe(
            (res) => {
                this.shipmentRates = res;
                this.appMainService.isHideSpinner("loadrates");
            },
            (e) => {
                this.createLabelSubmitted = false;
                this.appMainService.isHideSpinner("loadrates");
                this.messageService.add({
                    severity: "error",
                    summary: this.titlecasePipe.transform("error"),
                    detail: e?.error?.Message,
                });
            },
        );
    }
    getSinglePackageShippingCost() {
        this.ratesText = "Loading ...";
        const formValue = this.form.value.packages[0];
        const specialServiceTypes = this.getSpecialServiceTypes(formValue);
        const totalPck = Number(formValue.totalPackage.value);
        const ratesReqData = {
            accountNumber: {
                // value: formValue.account?.accountNumber,
                value: this.selectedFedexAcc?.accountNumber ?? "",
            },
            requestedShipment: {
                shipper: this.channel != this.soChannel.CUSTOMER_RETURNS ? this.prepareShipFromAddress(this.detailsObj) : this.prepareCustomerReturnShipFromAddress(this.shippingAddress, this.detailsObj),
                recipient: this.channel != this.soChannel.CUSTOMER_RETURNS ? this.prepareShipToAddress(this.shippingAddress, this.detailsObj) : this.prepareCustomerReturnShipToAddress(this.detailsObj),
                pickupType: formValue.pickupType?.value,
                ...(formValue.serviceType && formValue.serviceType != '' && {
                    serviceType: formValue.serviceType ?? "",
                }),
                packagingType:
                    formValue?.packageType?.label && formValue?.packageType?.label.startsWith("FEDEX") // CHECK-FEDEX
                        ? formValue?.packageType?.label
                        : "YOUR_PACKAGING",
                totalPackageCount: totalPck,
                totalWeight: Number(formValue.weight),
                rateRequestType: ["ACCOUNT", "LIST"],
                requestedPackageLineItems: [
                    {
                        ...(formValue.packageValue && {
                            declaredValue: {
                                amount: Number(formValue.packageValue),
                                currency: "USD",
                            },
                        }),
                        weight: {
                            units: "LB",
                            value: Number(formValue.weight),
                        },
                        dimensions: {
                            length: formValue.length ? Number(formValue.length) : 0,
                            width: formValue.width ? Number(formValue.width) : 0,
                            height: formValue.height ? Number(formValue.height) : 0,
                            units: "IN",
                        },
                        packageSpecialServices: {
                            specialServiceTypes: specialServiceTypes,
                            ...(formValue.signatureType && formValue.signatureType?.code != '' && {
                                signatureOptionType: formValue.signatureType.code,
                            }),
                            ...(formValue.cod && {
                                packageCODDetail: {
                                    codCollectionAmount: {
                                        amount: Number(formValue.codAmount),
                                        currency: "USD",
                                    },
                                    codCollectionType: "ANY",
                                },
                            }),
                            ...(formValue.batteryType && formValue.batteryType?.length > 0 && {
                                batteryDetails: this.prepareBatteryDetailsForRates(formValue.batteryType),
                            }),
                            ...(this.dryIceChecked && {
                                dryIceWeight: {
                                    units: "KG",
                                    value: this.convertlbsToKg(formValue.dryIceWeight ?? 0),
                                },
                            }),
                        },
                    },
                ],
            },
            ...(formValue.serviceType && formValue.serviceType && {
                carrierCodes: ["FDXE", "FDXG", "FXSP", "FXCC"]
            }),
        };
        let objEncStr = btoa(JSON.stringify(ratesReqData));
        this.shipmentRates = [];
        this.appMainService.isShowSpinner("loadrates");
        this.salesOrderService.getFedexRates(this.vendorFedexInfo?.id, objEncStr).subscribe(
            (res) => {
                this.shipmentRates = res;
                if(formValue.serviceType && formValue.serviceType != ""){
                    this.selectedService = res?.output?.rateReplyDetails?.find((r) => r.serviceType == formValue.serviceType);
                }
                if (!res) {
                    this.ratesText = "No rates found.";
                }
                this.appMainService.isHideSpinner("loadrates");
            },
            (e) => {
                this.createLabelSubmitted = false;
                this.messageService.add({
                    severity: "error",
                    summary: this.titlecasePipe.transform("error"),
                    detail: e?.error?.Message,
                });
                this.appMainService.isHideSpinner("loadrates");
            },
        );
    }
    /** End Shipment rates */

    prepareBatteryDetailsForRates(batteryTypes){
        let batteryDetails = batteryTypes?.map((b) => { return { material: b.materialType, regulatorySubType: "IATA_SECTION_II", packing: b.packingType } });
        return batteryDetails;
    }
    prepareBatteryDetailsForShipment(batteryTypes){
        let batteryDetails = batteryTypes?.map((b) => { return { batteryMaterialType: b.materialType, batteryRegulatoryType: "IATA_SECTION_II", batteryPackingType: b.packingType } });
        return batteryDetails;
    }

    /** Shipping services */
    getShippingServices() {
        const formValue = this.form.value.packages[0];
        const specialServiceTypes = this.getSpecialServiceTypes(formValue);
        const totalPck = Number(formValue.totalPackage.value);
        
        const shippingServiceReqData = {
            accountNumber: {
                value: this.selectedFedexAcc?.accountNumber ?? "",
            },
            requestedShipment: {
                shipper: this.channel != this.soChannel.CUSTOMER_RETURNS ? this.prepareShipFromAddress(this.detailsObj) : this.prepareCustomerReturnShipFromAddress(this.shippingAddress, this.detailsObj),
                recipient: this.channel != this.soChannel.CUSTOMER_RETURNS ? this.prepareShipToAddress(this.shippingAddress, this.detailsObj) : this.prepareCustomerReturnShipToAddress(this.detailsObj),
                pickupType: formValue?.pickupType?.value ?? "USE_SCHEDULED_PICKUP",
                packagingType:
                    formValue?.packageType?.label && formValue?.packageType?.label.startsWith("FEDEX") // CHECK-FEDEX
                        ? formValue?.packageType?.label
                        : "YOUR_PACKAGING",
                totalPackageCount: 1,
                totalWeight: 1,
                rateRequestType: ["ACCOUNT", "LIST"],
                requestedPackageLineItems: [
                    {
                        ...(formValue.packageValue && {
                            declaredValue: {
                                amount: Number(formValue.packageValue),
                                currency: "USD",
                            },
                        }),
                        weight: {
                            "units": "LB",
                            "value": 2
                        },
                        dimensions: {
                            "length": 2,
                            "width": 2,
                            "height": 2,
                            "units": "IN"
                        },
                        packageSpecialServices: {
                        },
                    },
                ],
                shipmentSpecialServices: {
                }
            },
        };
        this.appMainService.isShowSpinner("loadservices");
        this.salesOrderService.getShippingServices(shippingServiceReqData, this.vendorFedexInfo?.id).subscribe(
            (res) => {
                let services = [
                    {
                        label: '', 
                        value: '',
                        items: res?.output?.serviceOptionsList?.map((s) => { return { label: s.serviceType, value: s.serviceType, data: s, group: 1 }})
                    }
                ];
                this.serviceTypes = services;
                this.appMainService.isHideSpinner("loadservices");
                this.setDefaultServiceTypeForPackages();
                this.setDefaultDeclaredValue();
            },
            (e) => {
                this.createLabelSubmitted = false;
                this.messageService.add({
                    severity: "error",
                    summary: this.titlecasePipe.transform("error"),
                    detail: e?.error?.Message,
                });
                this.appMainService.isHideSpinner("loadservices");
            },
        );
    }

    setDefaultServiceTypeForPackages() {
        const defaultService = this.configuredFedexShippingServices?.find((s) => s.isDefault == true);
        const defaultServiceType = this.serviceTypes?.[0]?.items?.find((s) => s.label == defaultService?.description);

        if(defaultServiceType && defaultServiceType.label){
            const packagesArray = this.form.get('packages') as FormArray;
            packagesArray.controls.forEach((packageGroup: FormGroup) => {
                packageGroup.get('serviceType').setValue(defaultServiceType.label);
            });
            this.changeService(defaultServiceType);
        }
    }

    setDefaultDeclaredValue() {
        if(this.detailsObj){
            const packagesArray = this.form.get('packages') as FormArray;
            packagesArray.controls.forEach((packageGroup: FormGroup) => {
                packageGroup.get('packageValue').setValue(this.detailsObj.totalAmount);
            });
        }
    }

    /** Generate Shipment Label */
    createLabel() {
        this.isSinglePackage = true;
        if (this.isSinglePackage) {
            this.createLabelForSinglePackage();
        } else {
            this.createLabelForMultiplePackage();
        }
    }
    createLabelForSinglePackage() {
        this.createLabelSubmitted = true;
        const formValue = this.form.value.packages[0];
        const specialServiceTypes = this.getSpecialServiceTypes(formValue);
        const totalPck = Number(formValue.totalPackage.value);
        const saturdaySpecialServiceTypes = this.isSaturdayDeliveryChecked ? ["SATURDAY_DELIVERY"] : [];

        const data = {
            labelResponseOptions: "URL_ONLY",
            requestedShipment: {
                shipper: this.channel != this.soChannel.CUSTOMER_RETURNS ? this.prepareShipFromAddress(this.detailsObj) : this.prepareCustomerReturnShipFromAddress(this.shippingAddress, this.detailsObj),
                recipients: this.channel != this.soChannel.CUSTOMER_RETURNS ? [this.prepareShipToAddress(this.shippingAddress, this.detailsObj)] : [this.prepareCustomerReturnShipToAddress(this.detailsObj)],
                shipDatestamp: moment(formValue.shipDate).format("YYYY-MM-DD"),
                ...(formValue.packageValue && {
                    totalDeclaredValue: {
                        amount: Number(formValue.packageValue),
                        currency: "USD",
                    },
                }),
                serviceType: this.selectedService?.serviceType,
                packagingType:
                    formValue?.packageType?.label && formValue?.packageType?.label.startsWith("FEDEX") // CHECK-FEDEX
                        ? formValue?.packageType?.label
                        : "YOUR_PACKAGING",
                pickupType: formValue.pickupType?.value,
                blockInsightVisibility: true,
                totalPackageCount: totalPck,
                totalWeight: Number(formValue.weight),
                shippingChargesPayment: {
                    paymentType: "SENDER",
                },
                labelSpecification: {
                    imageType: "PDF",
                    labelStockType: "PAPER_4X6",
                },
                shipmentSpecialServices: {
                    specialServiceTypes: saturdaySpecialServiceTypes
                },
                requestedPackageLineItems: [
                    {
                        customerReferences: [
                            {
                                customerReferenceType: "INVOICE_NUMBER",
                                value: formValue.reference1,
                            },
                        ],
                        ...(formValue.packageValue && {
                            declaredValue: {
                                amount: Number(formValue.packageValue),
                                currency: "USD",
                            },
                        }),
                        weight: {
                            value: Number(formValue.weight),
                            units: "LB",
                        },
                        dimensions: {
                            length: formValue.length ? Number(formValue.length) : 0,
                            width: formValue.width ? Number(formValue.width) : 0,
                            height: formValue.height ? Number(formValue.height) : 0,
                            units: "IN",
                        },
                        packageSpecialServices: {
                            specialServiceTypes: specialServiceTypes,
                            ...(formValue.signatureType && formValue.signatureType?.code != '' && {
                                signatureOptionType: formValue.signatureType.code,
                            }),
                            ...(formValue.cod && {
                                packageCODDetail: {
                                    codCollectionAmount: {
                                        amount: Number(this.codAmount),
                                        currency: "USD",
                                    },
                                },
                            }),
                            ...(formValue.batteryType && formValue.batteryType?.length > 0 && {
                                batteryDetails: this.prepareBatteryDetailsForShipment(formValue.batteryType),
                            }),
                            ...(this.dryIceChecked && {
                                dryIceWeight: {
                                    units: "KG",
                                    value: this.convertlbsToKg(formValue.dryIceWeight ?? 0),
                                },
                            }),
                        },
                    },
                ],
            },
            accountNumber: {
                value: this.selectedFedexAcc?.accountNumber ?? ""
            },
            shipAction: "CONFIRM",
            carrierCodes: ["FDXE", "FDXG", "FXSP", "FXCC"]
        };

        let objEncStr = JSON.stringify(data);
        const obj = {
            vendorID: this.vendorFedexInfo?.id,
            shipment: objEncStr,
        };
        this.salesOrderService.createFedexLabel(obj).subscribe(
            (res) => {
                if (res) {
                    const data = {
                        type: "SINGLE_PACKAGE",
                        success: true,
                        label: res,
                        // accountNo: formValue.account?.accountNumber,
                        accountNo: this.selectedFedexAcc?.accountNumber ?? "",
                        selectedCarrier: this.selectedCarrier,
                        shippingCost: this.shippingCost,
                        isFreeShipping: this.isFreeShipping,
                        codCharge: formValue.cod ? formValue.codAmount : 0,

                        length: Number(formValue.length),
                        width: Number(formValue.width),
                        height: Number(formValue.height),
                        weight: Number(formValue.weight),
                        zipCode: this.shippingAddress?.address?.zipCode ?? "",
                        addressTypeId: this.shippingAddress?.address?.addressTypeId ?? "",
                        addressClassId: this.shippingAddress?.address?.addressClassId ?? "",
                        uomId: 0,
                        uomName: "Pound",
                        serviceName: this.selectedService?.serviceName ?? "",
                        serviceMethodTypeId: 0,
                    };
                    this.messageService.add({
                        severity: "success",
                        summary: this.titlecasePipe.transform("success"),
                        detail: "Label created Successfully...",
                    });
                    this.createLabelSubmitted = false;
                    this.onFedexLabelCreate.emit(data);
                } else {
                    this.appMainService.isHideSpinner("createLabel");
                    this.createLabelSubmitted = false;
                    this.messageService.add({
                        severity: "error",
                        summary: this.titlecasePipe.transform("error"),
                        detail: "",
                    });
                }
            },
            (e) => {
                this.appMainService.isHideSpinner("createLabel");
                this.createLabelSubmitted = false;
                this.messageService.add({
                    severity: "error",
                    summary: this.titlecasePipe.transform("error"),
                    detail: e?.error?.Message,
                });
            },
        );
    }
    createLabelForMultiplePackage() {
        this.createLabelSubmitted = true;
        const shipments = [];
        let totalWeight = 0;
        this.form.value.packages.forEach((pck) => {
            for (let i = 0; i < Number(pck.totalPackage.value); i++) {
                const obj = {
                    groupPackageCount: 1,
                    weight: {
                        units: "LB",
                        value: Number(pck.weight),
                    },
                    dimensions: {
                        length: pck.length ? Number(pck.length) : 0,
                        width: pck.width ? Number(pck.width) : 0,
                        height: pck.height ? Number(pck.height) : 0,
                        units: "IN",
                    },
                    ...(pck.cod && {
                        packageSpecialServices: {
                            specialServiceTypes: [],
                            packageCODDetail: {
                                codCollectionAmount: {
                                    amount: Number(formValue.codAmount),
                                    currency: "USD",
                                },
                            },
                        },
                    }),
                };
                totalWeight += Number(pck.weight);
                shipments.push(obj);
            }
        });

        const formValue = this.form.value.packages[0];
        const data = {
            labelResponseOptions: "URL_ONLY",
            requestedShipment: {
                shipper: this.channel != this.soChannel.CUSTOMER_RETURNS ? this.prepareShipFromAddress(this.detailsObj) : this.prepareCustomerReturnShipFromAddress(this.shippingAddress, this.detailsObj),
                recipients: this.channel != this.soChannel.CUSTOMER_RETURNS ? [this.prepareShipToAddress(this.shippingAddress, this.detailsObj)] : [this.prepareCustomerReturnShipToAddress(this.detailsObj)],
                shipDatestamp: moment(formValue.shipDate).format("YYYY-MM-DD"),
                serviceType: this.selectedService?.serviceType,
                packagingType:
                    formValue?.packageType?.label && formValue?.packageType?.label.startsWith("FEDEX") // CHECK-FEDEX
                        ? formValue?.packageType?.label
                        : "YOUR_PACKAGING",
                pickupType: formValue.pickupType?.value,
                blockInsightVisibility: false,
                shippingChargesPayment: {
                    paymentType: "SENDER",
                },
                labelSpecification: {
                    imageType: "PDF",
                    // labelStockType: "PAPER_85X11_TOP_HALF_LABEL",
                    labelStockType: "PAPER_4X6",
                },
                ...(formValue.cod && {
                    shipmentSpecialServices: {
                        specialServiceTypes: ["COD"],
                        shipmentCODDetail: {
                            codCollectionType: "ANY",
                        },
                    },
                }),
                requestedPackageLineItems: shipments,
            },
            accountNumber: {
                // value: formValue.account?.accountNumber,
                value: this.selectedFedexAcc?.accountNumber ?? "",
            },
        };

        let objEncStr = btoa(JSON.stringify(data));
        this.salesOrderService.createFedexLabel(objEncStr).subscribe(
            (res) => {
                if (res) {
                    const data = {
                        type: "MULTIPLE_PACKAGE",
                        success: true,
                        label: res,
                        accountNo: this.selectedFedexAcc?.accountNumber ?? "",
                        selectedCarrier: this.selectedCarrier,
                        shippingCost: this.shippingCost,
                        isFreeShipping: this.isFreeShipping,
                        codCharge: formValue.cod ? formValue.codAmount : 0,
                        length: Number(formValue.length),
                        width: Number(formValue.width),
                        height: Number(formValue.height),
                        weight: Number(formValue.weight),
                        zipCode: this.shippingAddress?.address?.zipCode ?? "",
                        addressTypeId: this.shippingAddress?.address?.addressTypeId ?? "",
                        addressClassId: this.shippingAddress?.address?.addressClassId ?? "",
                        uomId: 0,
                        uomName: "Pound",
                        serviceName: this.selectedService?.serviceName ?? "",
                        serviceMethodTypeId: 0,
                    };
                    this.messageService.add({
                        severity: "success",
                        summary: this.titlecasePipe.transform("success"),
                        detail: "Label created Successfully...",
                    });
                    this.createLabelSubmitted = false;
                    this.onFedexLabelCreate.emit(data);
                } else {
                    this.appMainService.isHideSpinner("createLabel");
                    this.createLabelSubmitted = false;
                    this.messageService.add({
                        severity: "error",
                        summary: this.titlecasePipe.transform("error"),
                        detail: "",
                    });
                }
            },
            (e) => {
                this.appMainService.isHideSpinner("createLabel");
                this.createLabelSubmitted = false;
                this.messageService.add({
                    severity: "error",
                    summary: this.titlecasePipe.transform("error"),
                    detail: e?.error?.Message,
                });
            },
        );
    }

    /** End Generate Shipment label */

    getSpecialServiceTypes(formValue) {
        const specialServiceTypes = [];
        if (formValue?.cod) {
            specialServiceTypes.push("COD");
        }
        if (formValue.batteryType && formValue.batteryType?.length > 0) {
            specialServiceTypes.push("BATTERY");
        }
        if (this.dryIceChecked) {
            specialServiceTypes.push("DRY_ICE");
        }
        if (formValue.signatureType && formValue.signatureType?.code != "") {
            specialServiceTypes.push("SIGNATURE_OPTION");
        }
        return specialServiceTypes;
    }

    onDialogClose() {
        this.onClose.emit();
    }

    isNumberKey(evt) {
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
        return true;
    }

    showCodField() {
        this.isVisibleCodField = true;
    }

    hideCodField() {
        this.isVisibleCodField = false;
    }

    showShippingCostField() {
        this.isVisibleShipCostField = true;
    }

    hideShippingCostField() {
        this.isVisibleShipCostField = false;
        this.codAmount = 0;
        const formValue = this.form.value.packages[0];
        if (formValue?.cod && formValue.codAmount) {
            this.codAmount += Number(formValue.codAmount);
        }
        if (formValue?.cod) {
            this.codAmount += Number(this.shippingCost) + Number(this.detailsObj.netAmount);
        }
    }

    calculateCODAmount() {
        /**
         * Total COD amount is addition of ordertotal, service cost & cod charge
         */
        this.codAmount = 0;
        const formValue = this.form.value.packages[0];
        if (formValue?.cod && formValue.codAmount) {
            this.codAmount += Number(formValue.codAmount);
        }
        if (formValue?.cod) {
            this.codAmount += Number(this.selectedService?.ratedShipmentDetails[0]?.totalNetFedExCharge) + Number(this.detailsObj.netAmount);
        }
    }

    checkNameLength(data) {
        let name = "";
        if (data) {
            name = data.length > 30 ? data.substring(0, 30) : data;
        }
        return name;
    }

    checkStreetAddressLength(shipAddress) {
        let address = "";
        if (shipAddress?.address?.streetAddress1) {
            address = shipAddress?.address?.streetAddress1.length > 35 ? shipAddress?.address?.streetAddress1.substring(0, 35) : shipAddress?.address?.streetAddress1;
        } else if (shipAddress?.address?.streetAddress2) {
            address = shipAddress?.address?.streetAddress2.length > 35 ? shipAddress?.address?.streetAddress2.substring(0, 35) : shipAddress?.address?.streetAddress2;
        }
        return address;
    }
    changeService(e){
        this.signatureTypes = e?.data?.signatureOptionsList ?? [];
        this.isVisibleBatteryField = e?.data?.packageSpecialServicesList?.find((s) => s?.specialServiceType === "BATTERY") ? true : false;
        for(let s of this.serviceTypes) {
            for(let m of s.items){
                if(e.value === m.value ){
                    this.selectedServiceType = m;
                }
            }
        }

        this.onChangeServiceAndDateFetchSpecialServices();
    }

    onShipDateSelect(i) {
        this.onChangeServiceAndDateFetchSpecialServices();
    }

    onChangeServiceAndDateFetchSpecialServices() {
        const formValue = this.form.value.packages[0];
        if(formValue?.serviceType && formValue?.shipDate) { 
            const shippingServiceReqData = {
                accountNumber: {
                    value: this.selectedFedexAcc?.accountNumber ?? "",
                },
                requestedShipment: {
                    shipper: this.channel != this.soChannel.CUSTOMER_RETURNS ? this.prepareShipFromAddress(this.detailsObj) : this.prepareCustomerReturnShipFromAddress(this.shippingAddress, this.detailsObj),
                    recipient: this.channel != this.soChannel.CUSTOMER_RETURNS ? this.prepareShipToAddress(this.shippingAddress, this.detailsObj) : this.prepareCustomerReturnShipToAddress(this.detailsObj),
                    pickupType: formValue?.pickupType?.value ?? "USE_SCHEDULED_PICKUP",
                    serviceType: formValue?.serviceType,
                    shipDateStamp: moment(formValue.shipDate).format("YYYY-MM-DD"),
                    packagingType:
                        formValue?.packageType?.label && formValue?.packageType?.label.startsWith("FEDEX")
                            ? formValue?.packageType?.label
                            : "YOUR_PACKAGING",
                    totalPackageCount: 1,
                    totalWeight: 1,
                    rateRequestType: ["ACCOUNT", "LIST"],
                    requestedPackageLineItems: [
                        {
                            ...(formValue.packageValue && {
                                declaredValue: {
                                    amount: Number(formValue.packageValue),
                                    currency: "USD",
                                },
                            }),
                            weight: {
                                "units": "LB",
                                "value": 2
                            },
                            dimensions: {
                                "length": 2,
                                "width": 2,
                                "height": 2,
                                "units": "IN"
                            },
                            packageSpecialServices: {
                            },
                        },
                    ],
                    shipmentSpecialServices: {
                    },
                    specialServicesRequested: {
                        saturdayDeliveryDetail: {
                            locationContactAndAddress: this.channel != this.soChannel.CUSTOMER_RETURNS ? this.prepareShipToAddress(this.shippingAddress, this.detailsObj) : this.prepareCustomerReturnShipToAddress(this.detailsObj),
                        },
                    }
                },
            };
            
            this.appMainService.isShowSpinner("loadservices");
            this.salesOrderService.getShippingServices(shippingServiceReqData, this.vendorFedexInfo?.id).subscribe(
                (res) => {
                    this.appMainService.isHideSpinner("loadservices");
                    const saturdayDeliveryService = res?.output?.serviceOptionsList?.[0]?.shipmentSpecialServicesList?.find((s) => s?.specialServiceType === this.saturdaySpecialServiceType);
                    this.saturdayDeliveryAvailable = !!saturdayDeliveryService;
                },
                (e) => {
                    this.messageService.add({
                        severity: "error",
                        summary: this.titlecasePipe.transform("error"),
                        detail: e?.error?.Message,
                    });
                    this.appMainService.isHideSpinner("loadservices");
                },
            );
        }

    }

    convertlbsToKg(pounds) {
        const conversionFactor = 0.453592;
        const kilograms = pounds * conversionFactor;
        return kilograms;
    }
}
